import React from 'react';
import { css } from '@emotion/react';
import isNil from 'lodash-es/isNil';
import { i18n_continue_watching } from '@yi/i18n/phrases/i18n_continue_watching';
import { i18n_first_episode } from '@yi/i18n/phrases/i18n_first_episode';

import type { Series } from '~/src/common/lean-back';
import { useLocale } from '~/src/components/LocaleProvider';
import { breakpoints } from '~/styles';

import { SeriesEpisodeCard } from './SeriesEpisodeCard';
import { useContinueWatchingEpisode } from './useContinueWatchingEpisode';

const styles = {
  container: css({
    position: 'relative',
    paddingBottom: '12px',
    display: 'flex',
    [breakpoints.minTablet]: {
      paddingLeft: '16px',
      float: 'right',
    },
  }),
  cardContainer: css({
    display: 'flex',
    position: 'relative',
    width: '100%',
    justifyContent: 'center',
  }),
};

type Props = { series: Series };

export const ContinueWatching: React.FC<Props> = ({ series }) => {
  const { locale } = useLocale();
  const { isFirstWatch, nextEpisode, percentComplete } = useContinueWatchingEpisode(series);

  if (isNil(nextEpisode)) {
    return null;
  }
  const chipText = isFirstWatch ? i18n_first_episode(locale) : i18n_continue_watching(locale);
  return (
    <div css={styles.container}>
      <div css={styles.cardContainer}>
        <SeriesEpisodeCard
          details={nextEpisode}
          percentComplete={percentComplete}
          chipText={chipText}
        />
      </div>
    </div>
  );
};
